import React from "react";
// import BradcrumeSection from "../Others/BradcrumeSection";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./FreeLegalAdviceCSS.css";
import LegalBradcrumeSection from "./LegalBradcrumeSection";
// import LegalAdviceDetailsForm from "./LegalAdviceDetailsForm";
import { Autocomplete, TextField } from "@mui/material";
import QuestionAnswereBox from "./QuestionAnswereBox";
import LegalProfileBox from "./LegalProfileBox";
import { AllCommunityService, AllCommunityServiceQuestion } from "../FetchAPI";
import { useAuth } from "../../Store/AuthContext";
// import { AllCommunityService } from "../FetchAPI";

export default function LegalAdviceDetails() {
  const { RendomTokenfetch } = useAuth();
  let { communityCatslug, communitySerSlug } = useParams();

  const [AllserviceCat] = AllCommunityService(
    RendomTokenfetch,
    "",
    communityCatslug
  );

  const [CommunitSer, AllserviceQuestion] = AllCommunityServiceQuestion(
    RendomTokenfetch,
    communitySerSlug
  );

  const navigate = useNavigate();

  // console.log(CommunitSer.community_service);

  const handleadviceCatChange = (event, value) => {
    // console.log(value.slug);
    if (value) {
      navigate(`/${communityCatslug}/${value.slug}`); // Update URL dynamically
    }
  };

  return (
    <>
      {/* <PageMetaTags
        meta_title={serviceQues.meta_title}
        metakeyword={serviceQues.metakeyword}
        metadesc={serviceQues.metadesc}
      /> */}
      <LegalBradcrumeSection
        Pagename={CommunitSer && CommunitSer.community_service}
        page1={[
          { name: `free-advice`, pagelink: "free-advice" },
          { name: `${communityCatslug}` },
          { name: `${communitySerSlug}` },
        ]}
      />

      <section
        className={`legal_section section_padding_top section_padding_bottom `}
        style={{ background: " #f5f7fc82" }}
      >
        <div className="auto-container">
          <div className="row wow fadeInUp">
            <div className="col-lg-8 col-md-12 Askformrow">
              <div className="searchAskqusBOX1 mb-4">
                <form className="mt-2">
                  <div className="row">
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-1">
                      <Autocomplete
                        className="communitySearchinput"
                        disablePortal
                        options={AllserviceCat}
                        getOptionLabel={(option) => option.community_service}
                        sx={{ width: "100%" }}
                        onChange={handleadviceCatChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Category"
                            size="small"
                          />
                        )}
                      />
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-1">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control communitySearchinput"
                          placeholder="Search Answers"
                        />
                        <Link className="input-group-text communitySearchinput">
                          <i className="fa fa-search"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="row wow fadeInUp">
            <div className="col-lg-8 col-md-12 Askformrow">
              {/* <div className="formdesedataBOX">
                <h4 className="formdescheading">
                  Connect with a {formatSlug(communitySerSlug)} lawyer in one
                  minute
                </h4>
                <div className="formdesctitlebox">
                  <div className="formDatarow">
                    <LegalAdviceDetailsForm />
                  </div>
                </div>
              </div> */}
              <div className="questionAnsBox mt-5">
                {AllserviceQuestion && AllserviceQuestion.length > 0 ? (
                  <QuestionAnswereBox AllserviceQuestion={AllserviceQuestion} />
                ) : (
                  <div className="text-center notfountCommunityQues">
                    <p className="NotFountHeading">No Question Found.</p>
                    <p>
                      Get <Link to="/ask-a-free-question">free advice</Link>{" "}
                      from top rated experts in India.
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="col-lg-4">
              <LegalProfileBox />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
